
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from '@/core/di/Inject';
import { TYPES } from '@/core/config/Types';
import { PreRegisterFindWithBulks } from '@/wms/application/preRegister/search/PreRegisterFindWithBulks';
import { PreRegister } from '@/wms/domain/preRegister/PreRegister';
import Timeline from '@/courier/infrastructure/ui/components/order/TimelineN/Timeline.vue';
import VueBarcode from 'vue-barcode';
import TimelineComponentFF from '@/tracking/infrastructure/ui/components/ff/timeline/TimelineComponentFF.vue';
import AppTimelineComponentFF from '@/tracking/infrastructure/ui/components/ff/timeline/TimelineComponentFF.vue';

@Component({
  name: 'HistoryPanel',
  components: { Timeline, VueBarcode, TimelineComponentFF, AppTimelineComponentFF }
})
export default class HistoryPanel extends Vue {
  @Inject(TYPES.PRE_REGISTER_FINDALL_WITH_BULKS)
  readonly findPreRegisters!: PreRegisterFindWithBulks;

  //Listas
  preRegisterList: PreRegister[] = [];
  //Data
  isLoading = false;

  mounted() {
    this.getAllPreregister();
  }

  //Funcion para obtener todos los pre registros con bultos
  async getAllPreregister(): Promise<void> {
    try {
      this.isLoading = true;
      const res: any = await this.findPreRegisters.execute('FREIGHT_SP');
      res.lines = res.bulks;
      this.preRegisterList = res.length > 0 ? res.reverse() : [];
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      throw new Error(`${error}`);
    }
  }
}
